import type { IntlShape } from 'react-intl'

const staticAppTextFormatters: Record<string, (intl: IntlShape) => string> = {
  'Australia': (intl) => intl.formatMessage({
    id: 'S1oajVah8hhEnNCM4DPb',
    defaultMessage: 'Australia',
    description: 'Config-driven destination label for Australia shown in footer, sidebar, or destination link surfaces',
  }),
  'Bali': (intl) => intl.formatMessage({
    id: 'WOyA5RqIk5UVg5lZLvYJ',
    defaultMessage: 'Bali',
    description: 'Config-driven destination label for Bali shown in footer, sidebar, or destination link surfaces',
  }),
  'Business Travel': (intl) => intl.formatMessage({
    id: '16puE9f3VvqdIi--y81T',
    defaultMessage: 'Business Travel',
    description: 'Config-driven label for the business travel link shown in shared navigation surfaces',
  }),
  'California': (intl) => intl.formatMessage({
    id: 'fEZKf2ZZ2jhP6TTkQzAH',
    defaultMessage: 'California',
    description: 'Config-driven destination label for California shown in footer, sidebar, or destination link surfaces',
  }),
  'Car Hire': (intl) => intl.formatMessage({
    id: '8ZwA9-ddQCEbp-_wRZZa',
    defaultMessage: 'Car Hire',
    description: 'Config-driven label for the car hire link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Cruises': (intl) => intl.formatMessage({
    id: 'gGAv1vuigbVBK6XhAtiL',
    defaultMessage: 'Cruises',
    description: 'Config-driven label for the cruises link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Cudo': (intl) => intl.formatMessage({
    id: 'Zwchbeoqwc48yfF2CWqO',
    defaultMessage: 'Cudo',
    description: 'Config-driven partner brand label for Cudo shown in footer or partner-brand surfaces',
  }),
  'CVFR Holidays': (intl) => intl.formatMessage({
    id: '3ot9et7DkSsaJ1fWnd_e',
    defaultMessage: 'CVFR Holidays',
    description: 'Config-driven brand label for CVFR Holidays shown in logo, footer, or partner-brand surfaces',
  }),
  'Deals': (intl) => intl.formatMessage({
    id: 'o7y1P2ZJe2cveNsm8hIv',
    defaultMessage: 'Deals',
    description: 'Config-driven partner brand label for Deals shown in footer or partner-brand surfaces',
  }),
  'Direct Maldives Flights': (intl) => intl.formatMessage({
    id: 'KjN2E89ePMc3CPA4jN-Z',
    defaultMessage: 'Direct Maldives Flights',
    description: 'Config-driven label for the direct Maldives flights link shown in shared navigation surfaces',
  }),
  'Europe': (intl) => intl.formatMessage({
    id: 'vxD8BB_rOSckGxbIE8TN',
    defaultMessage: 'Europe',
    description: 'Config-driven destination label for Europe shown in footer, sidebar, or destination link surfaces',
  }),
  'Experiences': (intl) => intl.formatMessage({
    id: 'kGv7JMD3Z3LNdQCA6K9r',
    defaultMessage: 'Experiences',
    description: 'Config-driven label for the experiences link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Fiji': (intl) => intl.formatMessage({
    id: 'ABamS609BY-BnSqrdPHC',
    defaultMessage: 'Fiji',
    description: 'Config-driven destination label for Fiji shown in footer, sidebar, or destination link surfaces',
  }),
  'Flights': (intl) => intl.formatMessage({
    id: 'rjkAgXNqcXA47CAL9sAD',
    defaultMessage: 'Flights',
    description: 'Config-driven label for the flights link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Gift Cards': (intl) => intl.formatMessage({
    id: 'Fdyo8GZ5KQkWvc75vhh_',
    defaultMessage: 'Gift Cards',
    description: 'Config-driven label for the gift cards link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Golf': (intl) => intl.formatMessage({
    id: 'nuEE-728_wfga96BmVdb',
    defaultMessage: 'Golf',
    description: 'Config-driven label for the golf link shown in shared navigation surfaces',
  }),
  'Groups': (intl) => intl.formatMessage({
    id: 'a-Ry45gISOQOTFqvRBKz',
    defaultMessage: 'Groups',
    description: 'Config-driven label for the groups link shown in shared navigation or footer surfaces',
  }),
  'Hawaii': (intl) => intl.formatMessage({
    id: 'FzHeDjXxCI80h5M_pALg',
    defaultMessage: 'Hawaii',
    description: 'Config-driven destination label for Hawaii shown in footer, sidebar, or destination link surfaces',
  }),
  'Holidays': (intl) => intl.formatMessage({
    id: 'mpbKIx7c9XM79v5UeRYu',
    defaultMessage: 'Holidays',
    description: 'Config-driven label for the holidays link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Home': (intl) => intl.formatMessage({
    id: 'j-noXtNNi7Kqihb9Fr1h',
    defaultMessage: 'Home',
    description: 'Config-driven label for the home link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Homes & Villas': (intl) => intl.formatMessage({
    id: '9FgjGNcJvHHrI0F8fEDp',
    defaultMessage: 'Homes & Villas',
    description: 'Config-driven label for the homes and villas link shown in shared navigation surfaces',
  }),
  'Hong Kong': (intl) => intl.formatMessage({
    id: 'sLuGhIDb-pnS_Ng3MtV4',
    defaultMessage: 'Hong Kong',
    description: 'Config-driven destination label for Hong Kong shown in footer, sidebar, or destination link surfaces',
  }),
  'Hotels': (intl) => intl.formatMessage({
    id: 'Du7wu76EAhcUNe7aYRrW',
    defaultMessage: 'Hotels',
    description: 'Config-driven label for the hotels link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Hotels & Resorts': (intl) => intl.formatMessage({
    id: 'hlNqY6uTwK8zCnHbuT-t',
    defaultMessage: 'Hotels & Resorts',
    description: 'Config-driven label for the hotels and resorts link shown in shared navigation or sidebar surfaces',
  }),
  'Inspiration': (intl) => intl.formatMessage({
    id: 'SCxm4dKRDfsQ5WcVPKtr',
    defaultMessage: 'Inspiration',
    description: 'Config-driven label for the inspiration link shown in shared navigation surfaces',
  }),
  'Indonesia': (intl) => intl.formatMessage({
    id: 'cmoVwEpDd6ithe0TSO88',
    defaultMessage: 'Indonesia',
    description: 'Config-driven destination label for Indonesia shown in footer, sidebar, or destination link surfaces',
  }),
  'Italy': (intl) => intl.formatMessage({
    id: 'ce7JUc_M-IXSrAgo2_s3',
    defaultMessage: 'Italy',
    description: 'Config-driven destination label for Italy shown in footer, sidebar, or destination link surfaces',
  }),
  'Japan': (intl) => intl.formatMessage({
    id: 'qxileo8AaoTRFTFwINal',
    defaultMessage: 'Japan',
    description: 'Config-driven destination label for Japan shown in footer, sidebar, or destination link surfaces',
  }),
  'LE Agent Hub': (intl) => intl.formatMessage({
    id: 'YCr-jL_qfc-yJKZii6NH',
    defaultMessage: 'LE Agent Hub',
    description: 'Config-driven brand label for LE Agent Hub shown in logo or partner-brand surfaces',
  }),
  'Luxury Escapes': (intl) => intl.formatMessage({
    id: '5turM7CS4vZ9TvX2xPHc',
    defaultMessage: 'Luxury Escapes',
    description: 'Config-driven brand label for Luxury Escapes shown in logo, footer, or partner-brand surfaces',
  }),
  'LuxPlus+': (intl) => intl.formatMessage({
    id: 't1VsvOs4hSp9vtiZ85XS',
    defaultMessage: 'LuxPlus+',
    description: 'Config-driven label for the LuxPlus+ membership program shown in shared navigation or account surfaces',
  }),
  'Travel Expo': (intl) => intl.formatMessage({
    id: 'kVmIG5QoGCLRexo-bjOx',
    defaultMessage: 'Travel Expo',
    description: 'Config-driven label for the Travel Expo (LE Live) event shown in shared navigation surfaces',
  }),
  'Maldives': (intl) => intl.formatMessage({
    id: 'NtfGeH6ION4a3nMwtqB9',
    defaultMessage: 'Maldives',
    description: 'Config-driven destination label for the Maldives shown in footer, sidebar, or destination link surfaces',
  }),
  'Maldives Bundles': (intl) => intl.formatMessage({
    id: 'YVAOYUDUw_0ZiP7xa-Fs',
    defaultMessage: 'Maldives Bundles',
    description: 'Config-driven label for the Maldives bundles campaign link shown in shared navigation surfaces',
  }),
  'More': (intl) => intl.formatMessage({
    id: 'iogTL25pepF33WNv_kzn',
    defaultMessage: 'More',
    description: 'Config-driven label for the more dropdown shown in shared navigation surfaces',
  }),
  'Purchase Credits': (intl) => intl.formatMessage({
    id: 'vo5zMX4Ce57R4qn3g5D5',
    defaultMessage: 'Purchase Credits',
    description: 'Config-driven label for the purchase credits link shown in shared navigation surfaces for spoof-mode users',
  }),
  'New Zealand': (intl) => intl.formatMessage({
    id: '8LyMQb4J4an8SKgCUm6q',
    defaultMessage: 'New Zealand',
    description: 'Config-driven destination label for New Zealand shown in footer, sidebar, or destination link surfaces',
  }),
  'Portugal': (intl) => intl.formatMessage({
    id: 'MqtamxZMb3cr9C2ndXrH',
    defaultMessage: 'Portugal',
    description: 'Config-driven destination label for Portugal shown in footer, sidebar, or destination link surfaces',
  }),
  'Refer a Friend': (intl) => intl.formatMessage({
    id: '1ibiA1tK4QuLynM1avt9',
    defaultMessage: 'Refer a Friend',
    description: 'Config-driven label for the refer-a-friend link shown in shared navigation surfaces',
  }),
  'Scoopon': (intl) => intl.formatMessage({
    id: '2U2DxbcGZdlBbHSmq7_M',
    defaultMessage: 'Scoopon',
    description: 'Config-driven partner brand label for Scoopon shown in footer or partner-brand surfaces',
  }),
  'Shop': (intl) => intl.formatMessage({
    id: 'h7dyYt-ykomT2vTkJyCO',
    defaultMessage: 'Shop',
    description: 'Config-driven label for the shop or marketplace link shown in shared navigation surfaces',
  }),
  'Singapore': (intl) => intl.formatMessage({
    id: 'XCNcq4pVg1kGdHvK4fen',
    defaultMessage: 'Singapore',
    description: 'Config-driven destination label for Singapore shown in footer, sidebar, or destination link surfaces',
  }),
  'Société': (intl) => intl.formatMessage({
    id: 'yUDJ6xWCQUgwyOFcurqS',
    defaultMessage: 'Société',
    description: 'Config-driven label for the Société loyalty program shown in shared navigation surfaces',
  }),
  'South Pacific': (intl) => intl.formatMessage({
    id: 'mQa2fvcicTHfOWz3AMZu',
    defaultMessage: 'South Pacific',
    description: 'Config-driven destination label for the South Pacific shown in footer, sidebar, or destination link surfaces',
  }),
  'Support': (intl) => intl.formatMessage({
    id: '9QaG60nE3rpbHlBuAlFK',
    defaultMessage: 'Support',
    description: 'Config-driven label for the support link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Spain': (intl) => intl.formatMessage({
    id: 'S3b7Hw7BJVxRRKY0Tn92',
    defaultMessage: 'Spain',
    description: 'Config-driven destination label for Spain shown in footer, sidebar, or destination link surfaces',
  }),
  'Thailand': (intl) => intl.formatMessage({
    id: 'Xgn83DWbXDLdcqaZIpY7',
    defaultMessage: 'Thailand',
    description: 'Config-driven destination label for Thailand shown in footer, sidebar, or destination link surfaces',
  }),
  'Tours': (intl) => intl.formatMessage({
    id: 'yOTXLZhiQJuObKxhBiJI',
    defaultMessage: 'Tours',
    description: 'Config-driven label for the tours link shown in shared navigation, footer, or sidebar surfaces',
  }),
  'Tours & Cruises': (intl) => intl.formatMessage({
    id: 'PQNDf9pmC-Df0AIS_TSF',
    defaultMessage: 'Tours & Cruises',
    description: 'Config-driven label for the combined tours and cruises link shown in shared navigation surfaces',
  }),
  'Travel Protection': (intl) => intl.formatMessage({
    id: 'qnb-VRE3XIXz11_ZWiFY',
    defaultMessage: 'Travel Protection',
    description: 'Config-driven label for the travel protection link shown in shared navigation surfaces',
  }),
  'Travelshoot': (intl) => intl.formatMessage({
    id: 'wR5CkMsrZ7fHOEvaoVXj',
    defaultMessage: 'Travelshoot',
    description: 'Config-driven partner brand label for Travelshoot shown in footer or partner-brand surfaces',
  }),
  'Treatme': (intl) => intl.formatMessage({
    id: 'Xh20pzxYOzWaJyyHpS63',
    defaultMessage: 'Treatme',
    description: 'Config-driven brand label for Treatme shown in logo, footer, or partner-brand surfaces',
  }),
  'Treat Me': (intl) => intl.formatMessage({
    id: 'x8tkc_CPqs1vW84wWzN0',
    defaultMessage: 'Treat Me',
    description: 'Config-driven partner brand label for Treat Me shown in footer or partner-brand surfaces',
  }),
  'United Kingdom': (intl) => intl.formatMessage({
    id: 'K5xBy4XP33X8CMcMl_I1',
    defaultMessage: 'United Kingdom',
    description: 'Config-driven destination label for the United Kingdom shown in footer, sidebar, or destination link surfaces',
  }),
  'United States': (intl) => intl.formatMessage({
    id: 'W_aKnL2yo8K5ISTZUUbr',
    defaultMessage: 'United States',
    description: 'Config-driven destination label for the United States shown in footer, sidebar, or destination link surfaces',
  }),
  'Ultra Lux': (intl) => intl.formatMessage({
    id: 'J7UdomXHkCph_5dLGjHm',
    defaultMessage: 'Ultra Lux',
    description: 'Config-driven label for the Ultra Lux product link shown in shared navigation surfaces',
  }),
  'Vietnam': (intl) => intl.formatMessage({
    id: '4bS7KqwvXEnp5Z2AbSd_',
    defaultMessage: 'Vietnam',
    description: 'Config-driven destination label for Vietnam shown in footer, sidebar, or destination link surfaces',
  }),
  'Visit Us In Store': (intl) => intl.formatMessage({
    id: 'OJY-V8ElE34mYkQ3bxv6',
    defaultMessage: 'Visit Us In Store',
    description: 'Config-driven label for the in-store visit link shown in shared navigation surfaces',
  }),
  'Weddings': (intl) => intl.formatMessage({
    id: 'NacytM3o5VYlYkVIKrLJ',
    defaultMessage: 'Weddings',
    description: 'Config-driven label for the weddings link shown in shared navigation or footer surfaces',
  }),
  'Africa': (intl) => intl.formatMessage({
    id: 'hWJ_vYz4lzsQRTB0OWyj',
    defaultMessage: 'Africa',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Amsterdam': (intl) => intl.formatMessage({
    id: 'hNOPPWseRk9RgJamg1Pc',
    defaultMessage: 'Amsterdam',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Anguilla': (intl) => intl.formatMessage({
    id: 'lfHMjpJGc4mOY9MiMKJe',
    defaultMessage: 'Anguilla',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Antigua and Barbuda': (intl) => intl.formatMessage({
    id: '9SN70SR_JmLDtSU4RiCE',
    defaultMessage: 'Antigua and Barbuda',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Auckland': (intl) => intl.formatMessage({
    id: 'RHjquyyrKla8G-WXWgN8',
    defaultMessage: 'Auckland',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Austria': (intl) => intl.formatMessage({
    id: 'Jbfbc2Cg6giBSVlW9hkc',
    defaultMessage: 'Austria',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Bangkok': (intl) => intl.formatMessage({
    id: 'I6IFmuEFd_4iTxu57TaI',
    defaultMessage: 'Bangkok',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Barcelona': (intl) => intl.formatMessage({
    id: '4089WxKfPjKjjz0AcXDk',
    defaultMessage: 'Barcelona',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Berlin': (intl) => intl.formatMessage({
    id: 'SgcZkKc1NLLbAMrZ-jHG',
    defaultMessage: 'Berlin',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Bermuda': (intl) => intl.formatMessage({
    id: 'zhUFA4Mbzpp3c6YqwqSm',
    defaultMessage: 'Bermuda',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Botswana': (intl) => intl.formatMessage({
    id: 'jii4Ve4N5bgPylPYyeJ-',
    defaultMessage: 'Botswana',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Brazil': (intl) => intl.formatMessage({
    id: 'SJT_5H0Ylg2NmVOBB2_b',
    defaultMessage: 'Brazil',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Brisbane': (intl) => intl.formatMessage({
    id: 'IhesHQ6M-0qIt2uK9YJY',
    defaultMessage: 'Brisbane',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Cairns': (intl) => intl.formatMessage({
    id: 'wWrqAwVnDhQyS2ikidar',
    defaultMessage: 'Cairns',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Cambodia': (intl) => intl.formatMessage({
    id: 'sMJC9qfkY87WziREnQEa',
    defaultMessage: 'Cambodia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Canada': (intl) => intl.formatMessage({
    id: 's9fMTqTh9dpQ2QhJT1nu',
    defaultMessage: 'Canada',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Canberra': (intl) => intl.formatMessage({
    id: 'ca7eZi7R8iuSvRtgxKou',
    defaultMessage: 'Canberra',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Central Coast': (intl) => intl.formatMessage({
    id: 'jAzPl15fgKGMRhoWL9xJ',
    defaultMessage: 'Central Coast',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Chiang Mai': (intl) => intl.formatMessage({
    id: 'G_ZxpxJOs1uXZxDJ5x2s',
    defaultMessage: 'Chiang Mai',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Chiang Rai': (intl) => intl.formatMessage({
    id: 'hiRPf1LbOaIcFXXX06Ga',
    defaultMessage: 'Chiang Rai',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'China': (intl) => intl.formatMessage({
    id: '4wCel1i_vL9lnm4I9R4Q',
    defaultMessage: 'China',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Christchurch': (intl) => intl.formatMessage({
    id: '2uNPLeBH_Y_YAiMQZjp1',
    defaultMessage: 'Christchurch',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Colombia': (intl) => intl.formatMessage({
    id: 'bj-0sz6JuPbzM4ksXuQ3',
    defaultMessage: 'Colombia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Cook Islands': (intl) => intl.formatMessage({
    id: 'NrhBqOFhd1tdcpF67EyN',
    defaultMessage: 'Cook Islands',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Costa Rica': (intl) => intl.formatMessage({
    id: 'JboiysXawBsEzievhzV6',
    defaultMessage: 'Costa Rica',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Croatia': (intl) => intl.formatMessage({
    id: 'Yl1xMhfj0u9sjd-GHa0V',
    defaultMessage: 'Croatia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Czechia': (intl) => intl.formatMessage({
    id: '4mZJW3VFNe1enE32-S6a',
    defaultMessage: 'Czechia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Darwin': (intl) => intl.formatMessage({
    id: 'iIL7gIU8JPjsmw5ZmDBp',
    defaultMessage: 'Darwin',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Dominican Republic': (intl) => intl.formatMessage({
    id: 'sLqjc5H4JjinSJBUoBJ_',
    defaultMessage: 'Dominican Republic',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Dubai': (intl) => intl.formatMessage({
    id: 'mlMFyHqhVmBpjt62cqXR',
    defaultMessage: 'Dubai',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Egypt': (intl) => intl.formatMessage({
    id: '3bhd1_2myVE5s8w9suiK',
    defaultMessage: 'Egypt',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Florida': (intl) => intl.formatMessage({
    id: 'cnfLPnU_o8UV-nh7jmjG',
    defaultMessage: 'Florida',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'France': (intl) => intl.formatMessage({
    id: 'TOywKWOld0AHKfpjArJ0',
    defaultMessage: 'France',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Germany': (intl) => intl.formatMessage({
    id: 'OmhYusTdVKY9B6UjPVFF',
    defaultMessage: 'Germany',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Gold Coast': (intl) => intl.formatMessage({
    id: 'leGxgCYe4ySczAI7ydt8',
    defaultMessage: 'Gold Coast',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Greece': (intl) => intl.formatMessage({
    id: 'sySLju2_KYMNIKkYFLc9',
    defaultMessage: 'Greece',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Hanoi': (intl) => intl.formatMessage({
    id: '6CANp7fmXgzR32QNCPQx',
    defaultMessage: 'Hanoi',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Ho Chi Minh': (intl) => intl.formatMessage({
    id: 'MNDk0ahjL-A5KrABZ2FV',
    defaultMessage: 'Ho Chi Minh',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Hobart': (intl) => intl.formatMessage({
    id: 'e6BdFdAOTihzhWZPuH19',
    defaultMessage: 'Hobart',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Hungary': (intl) => intl.formatMessage({
    id: 'JIiPQ5N2z-L9yd2pJk2P',
    defaultMessage: 'Hungary',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Iceland': (intl) => intl.formatMessage({
    id: 'LY1b076cNoAIFtvlq79N',
    defaultMessage: 'Iceland',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'India': (intl) => intl.formatMessage({
    id: 'EoPL79BROnNkKioVJRph',
    defaultMessage: 'India',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Ireland': (intl) => intl.formatMessage({
    id: 'uiyDt0RP8_P1ua7zlTva',
    defaultMessage: 'Ireland',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Israel': (intl) => intl.formatMessage({
    id: 'CISD3f5ivmu1WZWzwTjW',
    defaultMessage: 'Israel',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Jamaica': (intl) => intl.formatMessage({
    id: 'Ahqfplk_Gk6lET9pLv4d',
    defaultMessage: 'Jamaica',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Jordan': (intl) => intl.formatMessage({
    id: 'U4ValHrEaU_8swDJG_78',
    defaultMessage: 'Jordan',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Khao Lak': (intl) => intl.formatMessage({
    id: '3juGZPKEMLqrD3gl-Rv_',
    defaultMessage: 'Khao Lak',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Koh Samui': (intl) => intl.formatMessage({
    id: '8Dliwhq4bnDSaNUFpkYs',
    defaultMessage: 'Koh Samui',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Krabi': (intl) => intl.formatMessage({
    id: 'yY1msmB2VHMLnQ4nQcAD',
    defaultMessage: 'Krabi',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Kuala Lumpur': (intl) => intl.formatMessage({
    id: 'RhZQBRuwuD5zaGZa3HSA',
    defaultMessage: 'Kuala Lumpur',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Langkawi': (intl) => intl.formatMessage({
    id: '2e3Asdn5SM6FVTbOK5wo',
    defaultMessage: 'Langkawi',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Laos': (intl) => intl.formatMessage({
    id: 'XqStiMQci2YFcizqFWmq',
    defaultMessage: 'Laos',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Launceston': (intl) => intl.formatMessage({
    id: '-pcye_iveqz3HzzGCcQe',
    defaultMessage: 'Launceston',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'London': (intl) => intl.formatMessage({
    id: 'Vfj4EL_kYIMbm2fi_D-e',
    defaultMessage: 'London',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Los Angeles': (intl) => intl.formatMessage({
    id: '2c32rPdIPvvMGsZeMnI_',
    defaultMessage: 'Los Angeles',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Macao': (intl) => intl.formatMessage({
    id: 'jYK86HqFWzA1ciU4IZP5',
    defaultMessage: 'Macao',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Madrid': (intl) => intl.formatMessage({
    id: 'fGklzuRtejQ2Abp8im1U',
    defaultMessage: 'Madrid',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Malaysia': (intl) => intl.formatMessage({
    id: 'o0_Z7gjLKWC67h_RhGnR',
    defaultMessage: 'Malaysia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Maldives Islands': (intl) => intl.formatMessage({
    id: 'y_BMVpBqV7nbtmBqSLVf',
    defaultMessage: 'Maldives Islands',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Malta': (intl) => intl.formatMessage({
    id: 'TBYk3yTCp1MWCUrdRdLH',
    defaultMessage: 'Malta',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Mauritius': (intl) => intl.formatMessage({
    id: '3Hsy3fNFYXxWXqAlH-TI',
    defaultMessage: 'Mauritius',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Mediterranean': (intl) => intl.formatMessage({
    id: 'kO6F7Q1-CIAA80CLFhto',
    defaultMessage: 'Mediterranean',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Melbourne': (intl) => intl.formatMessage({
    id: 'wTsAnVgR9E9JLnh_PB17',
    defaultMessage: 'Melbourne',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Mexico': (intl) => intl.formatMessage({
    id: 's27YfdhCgefB3N7gawph',
    defaultMessage: 'Mexico',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Milan': (intl) => intl.formatMessage({
    id: 'xuCEWuIgWUAYomET9yEb',
    defaultMessage: 'Milan',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Montenegro': (intl) => intl.formatMessage({
    id: 'XeJg3A60M7_CEjYQ-wgf',
    defaultMessage: 'Montenegro',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Morocco': (intl) => intl.formatMessage({
    id: 'A23S1S-LlPW2i-5EMOE0',
    defaultMessage: 'Morocco',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Netherlands': (intl) => intl.formatMessage({
    id: 'z9roSivAGU24RYmt1MpS',
    defaultMessage: 'Netherlands',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'New York': (intl) => intl.formatMessage({
    id: '8wG6FXe1Vt96Ci0FEvHi',
    defaultMessage: 'New York',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Oman': (intl) => intl.formatMessage({
    id: 'vHxghapNhP6-ehmKCjYD',
    defaultMessage: 'Oman',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Paris': (intl) => intl.formatMessage({
    id: 'PeloAdV_BhJsqZSaEcfF',
    defaultMessage: 'Paris',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Perth': (intl) => intl.formatMessage({
    id: 'Pykhh3QnRCKkZYYm130L',
    defaultMessage: 'Perth',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Peru': (intl) => intl.formatMessage({
    id: 'kENPLYkqzATI-OU8_21P',
    defaultMessage: 'Peru',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Philippines': (intl) => intl.formatMessage({
    id: 'YOVS-ACO2db011t8o93s',
    defaultMessage: 'Philippines',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Phuket': (intl) => intl.formatMessage({
    id: '_AULIEQ20En4zwv5PZEC',
    defaultMessage: 'Phuket',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Poland': (intl) => intl.formatMessage({
    id: 'gku8oCpLzvBQs2gcMK52',
    defaultMessage: 'Poland',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Port Douglas': (intl) => intl.formatMessage({
    id: 'Qj3_VD8rRIoJij_X70px',
    defaultMessage: 'Port Douglas',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Port Stephens': (intl) => intl.formatMessage({
    id: '958xr07x9cnyCCe4R9Rj',
    defaultMessage: 'Port Stephens',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Qatar': (intl) => intl.formatMessage({
    id: 'LNfVMsK3OJO27XxqU4ZB',
    defaultMessage: 'Qatar',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Queenstown': (intl) => intl.formatMessage({
    id: 'W5cugNm0FgtrvhKG23iy',
    defaultMessage: 'Queenstown',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Queensland': (intl) => intl.formatMessage({
    id: 'QjXMBx1DylKAas-9H9Io',
    defaultMessage: 'Queensland',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Rome': (intl) => intl.formatMessage({
    id: '58No8aEBvYa2ocNl-4-t',
    defaultMessage: 'Rome',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Rotarua': (intl) => intl.formatMessage({
    id: 'UOXX3xjYMgGmHDWlFqds',
    defaultMessage: 'Rotarua',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Rwanda': (intl) => intl.formatMessage({
    id: 'EobQ9aC9Uf-DYpXfj2A4',
    defaultMessage: 'Rwanda',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Saint Lucia': (intl) => intl.formatMessage({
    id: 'fYGWvUwzmK0dBq-6uMlH',
    defaultMessage: 'Saint Lucia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Samoa': (intl) => intl.formatMessage({
    id: 'BC0XcES21nyGtBsWgXVX',
    defaultMessage: 'Samoa',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'San Francisco': (intl) => intl.formatMessage({
    id: 'WRZYd-9aJ1jYVs4SSRFZ',
    defaultMessage: 'San Francisco',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Saudi Arabia': (intl) => intl.formatMessage({
    id: 'c6sjATG4J8lnvE57gWhg',
    defaultMessage: 'Saudi Arabia',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Seychelles': (intl) => intl.formatMessage({
    id: 'lwqaCrpFWW68x70tqF1L',
    defaultMessage: 'Seychelles',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Shanghai': (intl) => intl.formatMessage({
    id: 'FimGtQpu_NabqtqEjlkd',
    defaultMessage: 'Shanghai',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'South Africa': (intl) => intl.formatMessage({
    id: 'Dkgg5odCtLfLCoiBWPuB',
    defaultMessage: 'South Africa',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'South America': (intl) => intl.formatMessage({
    id: 'XPxXh17o6IMae5mvybzj',
    defaultMessage: 'South America',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'South Korea': (intl) => intl.formatMessage({
    id: 'IpXb28qfOijWVfGiZWfl',
    defaultMessage: 'South Korea',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Sri Lanka': (intl) => intl.formatMessage({
    id: '_NGMfjbwT8XtD_ddKzhQ',
    defaultMessage: 'Sri Lanka',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Sweden': (intl) => intl.formatMessage({
    id: 'DyimXelzm25e4QA-62Lc',
    defaultMessage: 'Sweden',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Switzerland': (intl) => intl.formatMessage({
    id: '6jvcNB5P_Z6UfVAXugkr',
    defaultMessage: 'Switzerland',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Sydney': (intl) => intl.formatMessage({
    id: '-TNVsuRbiesVdkBdQmVo',
    defaultMessage: 'Sydney',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Tanzania': (intl) => intl.formatMessage({
    id: 'GJzJHkl_Vz8IG6T0r5CR',
    defaultMessage: 'Tanzania',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Taupo': (intl) => intl.formatMessage({
    id: '8UpThZc0LmOoMalt9xkb',
    defaultMessage: 'Taupo',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'The Bahamas': (intl) => intl.formatMessage({
    id: 'aOLXTEAl1_KWXXVN599W',
    defaultMessage: 'The Bahamas',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Tokyo': (intl) => intl.formatMessage({
    id: 'P_qrUsleOZcqKHABsHUZ',
    defaultMessage: 'Tokyo',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Turkey': (intl) => intl.formatMessage({
    id: 'LttXUIWofEaCbqF83cCO',
    defaultMessage: 'Turkey',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Ubud': (intl) => intl.formatMessage({
    id: 'WKatH-qzAg6uzqTEQYUJ',
    defaultMessage: 'Ubud',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'UK': (intl) => intl.formatMessage({
    id: 'Akvido8uPHYGuxocOZ58',
    defaultMessage: 'UK',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'United Arab Emirates': (intl) => intl.formatMessage({
    id: 'jagTWYzGAf6ZyWxRm6OE',
    defaultMessage: 'United Arab Emirates',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'USA': (intl) => intl.formatMessage({
    id: 'o74QtHQXn9BAea-JrEPV',
    defaultMessage: 'USA',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Vanuatu': (intl) => intl.formatMessage({
    id: 'lx2JxxU8Ie5SV2xky1eL',
    defaultMessage: 'Vanuatu',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Venice': (intl) => intl.formatMessage({
    id: '2XhB4WSFIu0E5dJJpE-Y',
    defaultMessage: 'Venice',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
  'Zimbabwe': (intl) => intl.formatMessage({
    id: 'cQFWvZGDNG_Omo05meWA',
    defaultMessage: 'Zimbabwe',
    description: 'Config-driven geography label shown in top destinations, trending destinations, or shared destination link surfaces',
  }),
}

export default function formatStaticAppText(intl: IntlShape, text: string): string {
  return staticAppTextFormatters[text]?.(intl) ?? text
}
